import * as $ from 'jquery';
import 'bootstrap';
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";

export class ibeCTABtn {
	private $scope: any = $('[data-ibe-cta-btn]');

	init(): void {
		let _self = this;

		// possible target ibe options
		// - "book-flight"
		// - "check-in"
		// - "view-booking"
		// - "flight-status"
		_self.$scope.each(function(i:number) {
			const $el:any = $(this);
			const targetIbeSelector:string = $el.attr('data-target-ibe');
			const $deskIbeLink:any = $('#mab-bookingnav.desktop #bookingNav a.'+targetIbeSelector);
			const $mobIbeLink:any = $('#mab-bookingnav.mobile #bookingNav a.mobile-'+targetIbeSelector);

			$el.on('click.open-ibe touchstart.open-ibe ', function(e:any) {
				if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
					// desktop
					$deskIbeLink.trigger('click');
				} else {
					// mobile
					$mobIbeLink.trigger('click');
				}

	   		$(window).scrollTop(0);
			});
		});
		let ctaBtns: any = document.getElementsByClassName('campaign_cta-button');
		if(ctaBtns.length > 0) {
			for (let ctaBtn of ctaBtns) {
				ctaBtn.children[0].children[0].classList.remove('col-sm-4');
			}
		}
	}

	/**
	 * open and fully expand book flight ibe when redemption button
	 * with target href is clicked
	 */
	initBookFlight(): void {
		let _self = this;
		let href = '#ibe-flight-redemption'; // target href to open
		let redeemButton = $('a[href="'+href+'"]'); // target all links with this href value
		let bookFlightLink = $('.desktop#mab-bookingnav').find('a.book-flight');
		let mobBookFlightLink = $('.mobile#mab-bookingnav').find('a.mobile-book-flight');

		redeemButton.off('click').on('click', function(e:any) {
			e.preventDefault();
			e.stopPropagation();

			if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				// mobile
				// trigger click on desktop ibe link
				mobBookFlightLink.trigger('click');

				// expand book flight ibe
				// by default ibe only expands when departure date is selected
				// override by manually applying expanding criteria
				let mobbookflightIBE = $('#mobile-bookflight--container');
				mobbookflightIBE.addClass('expanded');
				mobbookflightIBE.find('.trip-container').show();
				mobbookflightIBE.find('.search-container').show();
				mobbookflightIBE.find('.search-container').show();
				mobbookflightIBE.find('.search-container').show();

			} else {
				// desktop
				// trigger click on desktop ibe link
				bookFlightLink.trigger('click');

				// expand book flight ibe
				// by default ibe only expands when departure date is selected
				// override by manually applying expanding criteria
				let bookflightIBE = $('#book-flight--container');
				bookflightIBE.find('[data-form-booking--trip]').addClass('expanded')
				bookflightIBE.find('.recent-container').show();
				bookflightIBE.find('.payment-type-container').show();
				bookflightIBE.find('.trip-container').show();
				bookflightIBE.find('.search-container').show();
			}
			adobeDataLayer.push('click', {
				'pageName': '',
				'pageType': 'Enrich Redemption Page - Flight',
				'clickName': 'click:btn-click:redeem-your-flights-now',
				'componentType': 'btn',
				'componentName': '',
				'componentID': '',
				'attributes': []
			});
			$(window).scrollTop(0);
		});
	}
}

let scope:Element = document.querySelector('body'); // applies to every page

if (scope){
	try {
		let ibectabtn = new ibeCTABtn();
		ibectabtn.init();
		ibectabtn.initBookFlight();
		var adobeDataLayer = new adobeDataLayerWrapper();
	} catch(e) {console.error(e);}
}
